/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import { USER_STATUSES } from 'constants/user'
import { SUBSCRIPTION_STATUS } from 'constants/subscription'
import { EMPTY_OBJECT, EMPTY_ARRAY } from 'constants/frozenObjects'
import { getSubscriptionPlans } from 'redux-app/selectors/subscription'
import { checkIsCardExpired, isContractExpired } from 'utils/date'

export const getUserDetails = state => state.user.userDetails.value
export const isPlanAcceptedMessageShown = state => state.user.isPlanAcceptedMessageShown
export const getUserSubscription = state => _get(getUserDetails(state), 'subscription', EMPTY_OBJECT)
export const getUserFutureSubscription = state => _get(getUserDetails(state), 'futureSubscription', EMPTY_OBJECT)
export const getUserCardInfo = state => _get(getUserDetails(state), 'creditCard', EMPTY_OBJECT)
export const getShippingHistory = state => _get(state, ['user', 'subscriptionHistory', 'value'], EMPTY_ARRAY)
export const getPaymentHistory = state => _get(state, ['user', 'paymentHistory', 'value'], EMPTY_ARRAY)
export const getUserId = state => _get(getUserDetails(state), 'userId')
export const getUserStatus = state => _get(getUserDetails(state), 'status')
export const isUserContractExpired = state =>
                    isContractExpired(_get(getUserDetails(state), 'subscription.termsEndDate'))
export const isUserSubscriptionCanceledByAdmin = state => {
  const adminCancellationReason = 6
  const cancellationReason = _get(getUserDetails(state), 'subscription.cancellationReasonId')

  return ((isUserSubscriptionCanceledOrWaitingForPrinter(state)) && cancellationReason == adminCancellationReason)
}
export const isUserSubscriptionCanceledOrWaitingForPrinter = state => {
  const subscriptionStatus = getSubscriptionStatus(state)
  return subscriptionStatus === SUBSCRIPTION_STATUS.canceled || subscriptionStatus === SUBSCRIPTION_STATUS.waitingForPrinter
}
export const isChangeSubscriptionAllowed = state => _get(getUserDetails(state), 'subscription.isChangeSubscriptionProcessAvailable')
export const isEnrollAvailable = state => isUserContractExpired(state) || (!isUserSubscriptionCanceledByAdmin(state) && isUserSubscriptionCanceledOrWaitingForPrinter(state))
export const isUserNeedsToRenewSubscription = state => _get(getUserDetails(state), 'subscription.isRenewalProcessAvailable')
export const isCardExpired = state => {
  const { expirationMonth, expirationYear } = getUserCardInfo(state)
  return checkIsCardExpired(expirationMonth, expirationYear)
}
export const isCaptchaRequiredForCreditCardChange = state =>  {
  const { isAdditionalProtectionRequired } = getUserCardInfo(state)
  return isAdditionalProtectionRequired
}
export const isCookieAccepted = state => state.user.isCookieAccepted
export const isUserAbleToOpenProfile = state => {
  const userDetails = getUserDetails(state)
  if (!userDetails) {
    return false
  }

  if ((getUserStatus(state) === USER_STATUSES.pending ||
       getUserStatus(state) === USER_STATUSES.active)
       && userDetails.subscription.termsAccepted 
       && userDetails.shippingAddress) {
    return true
  }

  return false;
}
export const isUserConfirmedEmail = state => _get(getUserDetails(state), 'emailConfirmed')
export const isCancelSubscriptionWithFee = state => _get(getUserSubscription(state), 'hasCancellationFee')
export const getSubscriptionCancellationFee = state => _get(getUserSubscription(state), 'cancellationFee')
export const isUserAbleToChangeSubscription = state => {
  const status = getSubscriptionStatus(state)
  return status === SUBSCRIPTION_STATUS.activated || status === SUBSCRIPTION_STATUS.pendingConfirmation
}
export const isUserAbleToCancelSubscription = state => _get(getUserSubscription(state), 'canCancelCurrentSubscription')
export const getSubscriptionStatus = state => _get(getUserSubscription(state), 'status')
export const getFutureSubscriptionStatus = state => _get(getUserFutureSubscription(state), 'status', EMPTY_OBJECT)
export const isUserUnableToUpdateInfo = state => {
  const status = getSubscriptionStatus(state)
  return ((status === SUBSCRIPTION_STATUS.canceled || status === SUBSCRIPTION_STATUS.waitingForPrinter) && !isUserContractExpired)
}
export const getUserActivePlanId = state => _get(getUserSubscription(state), 'planId')
export const isPrinterWillBeSentSoon = state => _get(getUserSubscription(state), 'isPrinterWillBeSentSoon')
export const getSubscriptionName = state => _get(getUserSubscription(state), 'planName', 'none')
export const isRenewalProcessAvailable = state => _get(getUserSubscription(state), 'isRenewalProcessAvailable')
export const isSubscriptionRenewed = state => _get(getUserSubscription(state), 'isSubscriptionRenewed')

export const getActivePlan = state => getSubscriptionPlans(state)
  .find(item => item.id === getUserActivePlanId(state))
export const getActivePlanPrice = state => {
  const activationFee = _get(getActivePlan(state), 'activationFee')
  const price = _get(getActivePlan(state), 'price')

  if (!activationFee) {
    return price
  }

  return activationFee + price
}
export const getActiveSubscriptionId = state => _get(getUserSubscription(state), 'id')
export const getActiveSubscriptionContractId = state => _get(getUserSubscription(state), 'contractId')
export const isChangeSubscriptionWithFee = state => _get(getUserSubscription(state), 'hasSubscriptionPlanChangeFee')
